













































import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'ImageUpload',
  props: {
    label: {
      type: String,
      default: 'Image',
    },
    value: {
      type: String,
      default: '',
    },
    uploadType: {
      type: String as PropType<'structure' | 'user'>,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    baseUrl: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      uploading: false,
      currentImage: this.value || '',
      imageTimestamp: Date.now(),
    }
  },
  computed: {
  },
  watch: {
    value(newVal) {
      this.currentImage = newVal
    },
  },
  methods: {
    getDisplayImageUrl(): string {
      if (!this.currentImage) {
        return ''
      }
      // Ajouter le timestamp sauvegaré lors de l'upload
      return this.imageUrl + (this.imageUrl.includes('?') ? '&' : '?') + `t=${this.imageTimestamp}`
    },
    triggerFileInput() {
      const input = this.$refs.fileInput as HTMLInputElement
      if (input) {
        input.click()
      } else {
        //console.error('File input not found')
      }
    },
    handleInputChange(event: Event) {
      const input = event.target as HTMLInputElement
      const files = input.files
      if (!files || files.length === 0) {
        return
      }
      this.handleFileChange(files[0])
    },
    async handleFileChange(file: File) {
      // Vérifier le type de fichier
      const allowedTypes = ['image/jpeg', 'image/png']
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('Seuls les fichiers JPG et PNG sont acceptés')
        return
      }

      // Vérifier la taille du fichier (200Ko = 204800 bytes)
      const maxSize = 200 * 1024
      if (file.size > maxSize) {
        this.$message.error('Le fichier ne doit pas dépasser 200Ko')
        return
      }

      // Vérifier les dimensions de l'image
      const isValidDimensions = await this.validateImageDimensions(file)
      if (!isValidDimensions) {
        this.$message.error('La hauteur de l\'image doit être inférieure à 500px')
        return
      }

      // Upload le fichier
      await this.uploadImage(file)
    },

    validateImageDimensions(file: File): Promise<boolean> {
      return new Promise((resolve) => {
        const img = new Image()
        const url = URL.createObjectURL(file)

        img.onload = () => {
          URL.revokeObjectURL(url)
          const isValid = img.height <= 500
          resolve(isValid)
        }

        img.onerror = () => {
          URL.revokeObjectURL(url)
          resolve(false)
        }

        img.src = url
      })
    },

    async uploadImage(file: File) {
      this.uploading = true

      const formData = new FormData()
      formData.append('image', file)


      const endpoint = this.uploadType === 'structure'
        ? `/structure/${this.entityId}/upload-logo`
        : `/user/${this.entityId}/upload-avatar`

      const response = await this.$api.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      if (response.data.success) {
        this.currentImage = response.data.data.filename
        this.imageTimestamp = Date.now()
        this.$emit('input', response.data.data.filename)
        //this.$emit('uploaded', response.data.data.filename)
        //this.$message.success('Image uploadée avec succès')
      }

      this.uploading = false
    },

    async removeImage() {
      this.$confirm('Êtes-vous sûr de vouloir supprimer cette image ?', 'Confirmation', {
        confirmButtonText: 'Oui',
        cancelButtonText: 'Annuler',
        type: 'warning',
      })
        .then(async () => {
          this.uploading = true

          const formData = new FormData()
          formData.append('remove', 'true')

          const endpoint = this.uploadType === 'structure'
            ? `/structure/${this.entityId}/upload-logo`
            : `/user/${this.entityId}/upload-avatar`

          const response = await this.$api.post(endpoint, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })

          if (response.data.success) {
            this.currentImage = ''
            this.$emit('input', '')
          }

          this.uploading = false
        })
        .catch(() => {
          // Annulé
        })
    },
  },
})
